import React from 'react'

const About = () => {
    return (
        <div className='bg-white h-screen 
        flex flex-col justify-center items-center'>
            <h1 className="lg:text-9xl ms:text-7xl sm:text-5xl 
            text-3xl font-black mb-14">
                About Section
            </h1>
        </div>
    )
}

export default About
